import React, { useContext, useState } from 'react';
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Stack from '@mui/material/Stack';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import ListItemIcon from '@mui/material/ListItemIcon';
import { useNavigate } from "react-router-dom";
//import { AuthInfoContext } from "./AuthContextProvider.tsx";
import pdf from "../pdf/管理サイトマニュアル.pdf";
import { API, MSG } from './constantsFront';
import axios from "axios";
import { MsgContext } from '../../App';

/**
 * 管理者画面のヘッダ　管理者名の表示とログアウト処理
 * @returns 
 */
export default function Logout() {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const navigate = useNavigate();
  const [authInfo, setAuthInfo] = useState(""); //useContext(AuthInfoContext);

  // エラーメッセージ
  const { msg, setMsg } = useContext(MsgContext);

  let body = { authKey: API.API_KEY };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
    console.log("ログアウト");

  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    // ログイン者名表示
    axios.post("/m_staff/auth")
      .then(res => {
        if (res.status == 200) {
          setAuthInfo(res.data.staff);
        }
      });

    prevOpen.current = open;
  }, [open]);


  /**
   * ログアウトボタン処理
   */
  const logoutClick = () => {
    localStorage.clear();
    const res = axios.post("/m_staff/logout", body);
    navigate("/G009AdminLogin");
  }

  /**
   * マニュアル
   */
  const manualClick = () => {
    window.open(pdf, "_blank");
  }

  return (
    <Stack direction="row" spacing={2}>
      <div>
        <Button
          ref={anchorRef}
          id="composition-button"
          aria-controls={open ? 'composition-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="true"
          variant="text"
          style={{ width: 'auto', backgroundColor: "white" }}
          onClick={handleToggle}
          endIcon={<KeyboardArrowDownIcon />}
        >
          {authInfo["staff_name"]}
        </Button>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom-start"
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === 'bottom-start' ? 'left top' : 'left bottom',
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                    onKeyDown={handleListKeyDown}
                  >
                    <MenuItem onClick={manualClick}>
                      <ListItemIcon>
                        <MenuBookIcon fontSize="small" />
                      </ListItemIcon>
                      マニュアル
                    </MenuItem>
                    <MenuItem onClick={logoutClick}>
                      <ListItemIcon>
                        <LogoutIcon fontSize="small" />
                      </ListItemIcon>
                      ログアウト
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </Stack>
  );
}


